import { PromotionTemplate } from "src/modules/promotions/api/promotions.api";

import { PromotionAspect } from "./getPromotionImageSize";

// Determines the banner's aspect ratio by the given template
export const getTemplateBannerAspect = (template: PromotionTemplate): PromotionAspect => {
  switch (template) {
    default:
    case PromotionTemplate.Small:
      return PromotionAspect.Small;

    case PromotionTemplate.Large:
      return PromotionAspect.Large;
  }
};
